let origin = "https://future.zhuneng.cn";
//明珠互动
const postInteractionUrl = `/gateway/hc-serve/miniapi/wechatInteractiveRecord/add`;
//明珠互动
const myInteractionUrl = `/gateway/hc-serve/miniapi/wechatInteractiveRecord/mineList`;

export { postInteractionUrl, myInteractionUrl };
